import { Box, Button, Typography } from '@mui/material';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { useNavigate } from 'react-router';

import { paths } from '@/config/paths';

interface PropertySectionProps {
  propertyName: string;
  propertyId: string;
}

export const PropertySection: React.FC<PropertySectionProps> = (props: PropertySectionProps) => {
  const navigate = useNavigate();
  const handleNavigateToPropertyDetail = () => {
    navigate(paths.property.getHref(props.propertyId));
  };
  return (
    <Box
      sx={{
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '28px',
      }}
    >
      <Typography
        component='span'
        sx={{
          color: 'var(--M3-sys-light-on-background, #1A1C20)',
          fontFamily: 'var(--Static-Title-Large-Font, "Noto Sans JP")',
          fontSize: 'var(--Static-Title-Large-Size, 22px)',
          fontStyle: 'normal',
          marginRight: '28px',
          fontWeight: 400,
          verticalAlign: 'middle',
        }}
      >
        {props.propertyName}
      </Typography>
      <Button
        variant='outlined'
        color='primary'
        onClick={handleNavigateToPropertyDetail}
        sx={{
          height: '40px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          border: '1px solid var(--M3-sys-light-primary, #0047BA)',
          background: 'var(--Schemes-On-Primary, #FFF)',
        }}
        startIcon={<LaunchOutlinedIcon />}
      >
        現場詳細
      </Button>
    </Box>
  );
};
